import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FinecoPage from "../pages/fineco/page";
import ServicesPage from "../pages/services/page";
import GalleryPage from "../pages/gallery/page";
import AboutPage from "../pages/about/page";
import FAQPage from "../pages/faq/page";
import ContactPage from "../pages/contact/page";
import KVKKPage from "../pages/legal/kvkk/page";
import PrivacyPage from "../pages/legal/privacy/page";
import CookiesPage from "../pages/legal/cookies/page";
import DistanceSalesPage from "../pages/legal/distance-sales/page";
import PreInfoPage from "../pages/legal/pre-info/page";
import ReturnPolicyPage from "../pages/legal/return-policy/page";
import DeliveryPage from "../pages/legal/delivery/page";
import TermsPage from "../pages/legal/terms/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/fineco-isi-pompasi",
    element: <FinecoPage />,
  },
  {
    path: "/hizmetlerimiz",
    element: <ServicesPage />,
  },
  {
    path: "/reklam-tanitimlarimiz",
    element: <GalleryPage />,
  },
  {
    path: "/hakkimizda",
    element: <AboutPage />,
  },
  {
    path: "/sik-sorulan-sorular",
    element: <FAQPage />,
  },
  {
    path: "/iletisim",
    element: <ContactPage />,
  },
  {
    path: "/kvkk-aydinlatma-metni",
    element: <KVKKPage />,
  },
  {
    path: "/gizlilik-politikasi",
    element: <PrivacyPage />,
  },
  {
    path: "/cerez-politikasi",
    element: <CookiesPage />,
  },
  {
    path: "/mesafeli-satis-sozlesmesi",
    element: <DistanceSalesPage />,
  },
  {
    path: "/on-bilgilendirme-formu",
    element: <PreInfoPage />,
  },
  {
    path: "/iptal-ve-iade-politikasi",
    element: <ReturnPolicyPage />,
  },
  {
    path: "/teslimat-hizmet-sureci",
    element: <DeliveryPage />,
  },
  {
    path: "/kullanim-sartlari",
    element: <TermsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;